import { render, staticRenderFns } from "./CommunityBusinessnews.vue?vue&type=template&id=4b1199e4&scoped=true"
import script from "./CommunityBusinessnews.vue?vue&type=script&lang=js"
export * from "./CommunityBusinessnews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1199e4",
  null
  
)

export default component.exports